module.exports = __webpack_public_path__ + "img/A1 (7).40dd595b.jpg";